import React from 'react';
import ReactDOM from 'react-dom';
import Emoticon from './Emoticon.react';
import EmoticonsButton from './EmoticonsButton.react';
import EmoticonsTabs from './EmoticonsTabs.react';
import requestFrame from 'request-frame';
// requestAnimationFrame polyfill
const request = requestFrame('request'); // requestAnimationFrame polyfill
import emojione from 'emojione';
import Scrollbars from './../misc/Scrollbars.react.js';
import get from 'lodash/get';
import cx from '../../utils/cx.js';

/* var nanoScroller = require('nanoScroller'); */

class EmoticonsPanel extends React.Component {
	static displayName = 'EmoticonsPanel';

	static defaultProps = {
	  addEmoticon: false,
	  prefix: 'emoji-',
	};

	constructor(props) {
	  super(props);
	  let basePath = get(globals, 'staticImageUri', '/static/img/');

	  this.state = {
	    spritePath: `${basePath}emojione/spritesheets/${props.pageId}.png${emojione.cacheBustParam}`,
	    target: null,
	  };
	}

	addEmoticon = (shortname) => {
	  if (this.props.addEmoticon) {
	    this.props.addEmoticon(shortname);
	  } else {
	    const $target = $(this.state.target).find('textarea');

	    $target[0].focus();
	    const oldValue = $target.val();
	    const caretPos = $target[0].selectionStart;
	    const newValue = `${oldValue.substring(0, caretPos) +
				shortname} ${
	      oldValue.substring(caretPos, oldValue.length)}`;
	    $target.val(newValue);
	    $target[0].selectionStart = $target[0].selectionEnd = caretPos + shortname.length + 1;
	    $target[0].focus();
	  }
	};

	componentDidMount() {
	  this.setState({
	    target: $(ReactDOM.findDOMNode(this)).parents('[data-emoticon-target]').data('emoticonTarget'),
	  });
	}

	// eslint-disable-next-line camelcase
	UNSAFE_componentWillReceiveProps(prevProps, nextProps) {
	  let basePath = get(globals, 'staticImageUri', '/static/img/');
	  this.setState({
	    spritePath: `${basePath}emojione/spritesheets/${prevProps.pageId}.png${emojione.cacheBustParam}`,
	  });
	}

	_onChange = (actionType) => {
	  this.setState(getEmoticonsState());
	};

	render() {
	  const emoticons = [];
	  for (const i in this.props.page.emoji) {
	    const emoji = this.props.page.emoji[i];
	    emoticons.push(<Emoticon
  panel
  key={emoji.id}
  spritePath={this.state.spritePath}
  shortname={emoji.shortname}
  id={this.props.prefix + emoji.id}
  addEmoticon={this.addEmoticon}
	    />);
	  }
	  return (
  <div className={
				cx(['emoticons-panel',
					['is-active', this.props.isOpen]])}
  >
    <EmoticonsTabs pageId={this.props.pageId} />
    <div className={cx([
					'emoticons-content',
					['loading', this.props.loading]])}
    >
      <Scrollbars
        className="emoticons-content-scrollbars"
        style={{ height: '100%' }}
        autoHide
      >
        <div className="emoticons">
          {emoticons}
        </div>
      </Scrollbars>
    </div>
  </div>
	  );
	}
}

module.exports = EmoticonsPanel;
